"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveBankrateId = exports.SAVE_BANKRATE_ID = void 0;

var _reduxActions = require("redux-actions");

/**
 * Replaced by user data layer.
 */
var SAVE_BANKRATE_ID = 'SAVE_BANKRATE_ID';
/**
 * Replaced by user data layer.
 */

exports.SAVE_BANKRATE_ID = SAVE_BANKRATE_ID;
var saveBankrateId = (0, _reduxActions.createAction)(SAVE_BANKRATE_ID);
exports.saveBankrateId = saveBankrateId;